<template>
  <v-container fluid>
    <v-row justify="center" align="center">
      <v-col cols="12" align="right">
        <v-btn color="primary" align="right" @click="openDialog"> Thêm </v-btn>
      </v-col>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="promotions"
          :items-per-page="10"
          class="elevation-1"
        >
          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" @click="editItem(item.id)" v-if="hasPermissions('Update promotion')">
              mdi-pencil
            </v-icon>
            <!--              <v-icon small class="mr-2" @click="reviewItem(item.id)">-->
            <!--                mdi-eye-->
            <!--              </v-icon>-->
            <v-icon small @click="deleteItem(item.id)" v-if="hasPermissions('Delete promotion')"> mdi-delete </v-icon>
          </template>
        </v-data-table>
      </v-col>

      <!--      dialog-->
      <v-dialog v-model="dialog" persistent max-width="600">
        <v-card class="rounded-lg">
          <v-card-title class="d-flex justify-center" v-if="hasPermissions('Create promotion')">
            Thêm quà tặng
          </v-card-title>
          <v-card-text>
            <v-col>
              <v-text-field
                type="text"
                background-color="#EDF2F7"
                filled
                v-model="name"
                placeholder="Nhập tên quà tặng"
                label="Tên"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                type="text"
                v-model="value"
                background-color="#EDF2F7"
                filled
                placeholder="Nhập tên quà tặng"
                label="Giá trị"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-autocomplete
                  background-color="#EDF2F7"
                  filled
                  item-value="id"
                  item-text="name"
                  :items="productions"
                  v-model="product_id"
                  label="Chọn sản phẩm"
              ></v-autocomplete>
            </v-col>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialog = false"> Hủy </v-btn>
            <v-btn v-if="is_edit" color="primary" text @click="update">
              Lưu
            </v-btn>
            <v-btn v-else color="primary" text @click="addNew"> Lưu </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import {
  GET_LIST_PROMOTIONS,
  DELETE_PROMOTIONS,
  GET_DETAIL_PROMOTIONS,
  UPDATE_PROMOTIONS,
  SET_DETAIL_PROMOTIONS,
  SAVE_PROMOTIONS
} from "@/store/modules/promotion_gift";
import { GET_LIST_PRODUCT_SEARCH} from '@/store/modules/production'

export default {
  data() {
    return {
      name: null,
      value: null,
      product_id: null,
      name_type: "",
      object_id: null,
      dialog: false,
      headers: [
        { text: "STT", value: "id" },
        { text: "Tên", value: "name" },
        { text: "Giá trị", value: "value" },
        { text: "Actions", value: "actions" },
        { text: "", value: "active" },
      ],
      url: "",
      is_edit: false,
    };
  },
  watch: {
    promotionDetail(val) {
      if (val) {
        this.name = val.name;
        this.value = val.value;
        this.product_id = val.product_id;
      }
    },
  },
  computed: {
    ...mapGetters({
      productions: "productionSearches",
      promotions: "promotions",
      promotionDetail: "promotionDetail",
      //   banner: 'banner',
      //   categories: 'categories',
      //   brands: 'brands',
      //   tags: 'tags',
    }),
  },
  async created() {
    await this.$store.dispatch(`${GET_LIST_PROMOTIONS}`);
    await this.$store.dispatch(`${GET_LIST_PRODUCT_SEARCH}`, {});
    // await this.$store.commit(`${SET_DETAIL_BANNER}`,{});
  },
  methods: {
    async addNew() {
        const _this = this;
        let form_promotion = {
            name : this.name,
            value : this.value,
            product_id : this.product_id
        }
      await _this.$store.dispatch(`${SAVE_PROMOTIONS}`, form_promotion).then((data) => {
        if (data.data.status===1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration:1000,
            position:'top-center'
          })
          _this.$store.dispatch(`${GET_LIST_PROMOTIONS}`);
          this.dialog = false;
        }else{
            alert(data.data.errors);
        }
      });
    },
    async update() {
      let form_promotion = {
        id: this.promotionDetail.id,
        name: this.name,
        value: this.value,
        product_id : this.product_id
      };
      await this.$store
        .dispatch(`${UPDATE_PROMOTIONS}`, form_promotion)
        .then((data) => {
          if (data.data.status===1) {
            this.$toasted.success('Cập nhật thành công!', {
              duration:1000,
              position:'top-center'
            })
            this.$store.dispatch(`${GET_LIST_PROMOTIONS}`);
            this.dialog = false;
          }else{
            alert(data.data.errors);
          }
        });
    },
    async openDialog() {
      this.is_edit = false;
      this.$store.commit(`${SET_DETAIL_PROMOTIONS}`, {});
      this.name = null;
      this.value = null;
      this.product_id = null;

      this.dialog = true;
    },
    async editItem(id) {
      this.is_edit = true;
      this.$store.dispatch(`${GET_DETAIL_PROMOTIONS}`, id).then((data) => {
        if (data) {
          this.dialog = true;
        }
      });
    },
    async deleteItem(id) {
      const _this = this;
      confirm("Bạn có chắc muốn xóa?") &&
        (await this.$store.dispatch(`${DELETE_PROMOTIONS}`, id).then((data) => {
          if (data && data.status === 1) {
            _this.$store.dispatch(`${GET_LIST_PROMOTIONS}`);
          }
        }));
    },
  },
};
</script>